import { AppScreens } from "../../screens/Utility/AppScreens";
import HomeWebScreen from "../../screens/Auth/WebScreens/HomeWebScreen";
import SearchEventWebScreen from "../../screens/Auth/WebScreens/SearchEventWebScreen";
import TicketDetailWebScreen from "../../screens/Auth/WebScreens/TicketDetailWebScreen";
import SettingWebScreen from "../../screens/Auth/WebScreens/SettingWebScreen";
import StreamSetup from "../../screens/Auth/WebScreens/StreamSetup";
import MyProfileWebScreen from "../../screens/Auth/WebScreens/MyProfileWebScreen";
import Notifications from "../../screens/Auth/WebScreens/Notifications/Notifications";
import CreatePrivateEventScreen from "../../screens/Auth/Event/CreatePrivateEventScreen";
import CreatePublicEventScreen from "../../screens/Auth/Event/CreatePublicEventScreen";
import EventSummary from "../../screens/Auth/Event/EventSummary";
import PrivateEventSummary from "../../screens/Auth/Event/PrivateEventSummary";
import PurchaseScreen from "../../screens/Auth/WebScreens/PurchaseScreen";
import RefundRequestScreen from "../../screens/Auth/WebScreens/RefundRequestScreen";
import ViewTrasactionHistory from "../../screens/Auth/WebScreens/ViewTrasactionHistory";
import TicketHistory from "../../screens/Auth/WebScreens/TicketHistory";
import UserProfile from "../../screens/Auth/WebScreens/UserProfile";
import HelpScreen from "../../screens/Auth/WebScreens/HelpScreen";
import DisputeCenter from "../../screens/Auth/WebScreens/DisputeCenter";
import MyEventsScreen from "../../screens/Auth/WebScreens/Events/MyEventsScreen";
import SearchMobileScreen from "../../screens/Auth/MobileScreens/SearchMobileScreen";
import OnGoingEvents from "../../screens/Auth/WebScreens/OnGoingEvents/OnGoingEvents";
import GameShowScreen from "../../screens/Auth/WebScreens/GameShowScreen";
import OnGoingEventsStreamingSetup from "../../screens/Auth/WebScreens/OnGoingEvents/OnGoingEventsStreamingSetup";
import Chat from "../../screens/Auth/WebScreens/ChatScreen/Chat";
import AddFriends from "../../screens/Auth/WebScreens/ChatScreen/AddFriends";
import LiveStreaming from "../../screens/Auth/WebScreens/OnGoingEvents/LiveStreaming";
import GoLive from "../../screens/Auth/WebScreens/UpComingEvents/GoLive";
import StreamerGoLive from "../../screens/Auth/WebScreens/GoLive/GoLivePage";
import ContactUsCenter from "../../screens/Auth/WebScreens/ContactUsCenter";
import CreateTicketEventScreen from "../../screens/Auth/Event/CreateTicketEventScreen";
import DisputeManagementScreen from "../../screens/Auth/WebScreens/DisputeManagementScreen";
import RedeemEventScreen from "../../screens/Auth/WebScreens/RedeemEventScreen";
import SearchGameWebScreen from "../../screens/Auth/WebScreens/SearchGameWebScreen";
import UpdatePublicEventScreen from "../../screens/Auth/Event/UpdatePublicEventScreen";
import UpdatePrivateEventScreen from "../../screens/Auth/Event/UpdatePrivateEventScreen";
import PastEvent from "../../screens/Auth/WebScreens/PastEventWebScreen";
import ChangeAvatar from "../../screens/Auth/WebScreens/ChangeAvatar";
import DisputeDetailScreen from "../../screens/Auth/WebScreens/DisputeDetailScreen";
import {
  PaymentSuccess,
  PaymentFailed,
  PaymentCancel,
} from "../../screens/Auth/WebScreens/Payment";
import SoloStreamingPage from "../../screens/Auth/WebScreens/SoloStreaming/SoloStreamingPage";

export const SHARED_SCREENS = {
  // Core screens used across multiple stacks
  SEARCH_EVENT: {
    name: AppScreens.SearchEventWebScreen,
    component: SearchEventWebScreen,
  },
  TICKET_DETAIL: {
    name: AppScreens.TicketDetailWebScreen,
    component: TicketDetailWebScreen,
  },
  PURCHASE: {
    name: AppScreens.PurchaseScreen,
    component: PurchaseScreen,
  },
  NOTIFICATIONS: {
    name: AppScreens.NotificationScreen,
    component: Notifications,
  },
  SETTINGS: {
    name: AppScreens.SettingWebScreen,
    component: SettingWebScreen,
  },
  HELP: {
    name: AppScreens.HelpScreen,
    component: HelpScreen,
  },
  STREAM_SETUP: {
    name: AppScreens.StreamSetup,
    component: StreamSetup,
  },
  TICKET_HISTORY: {
    name: AppScreens.TicketHistory,
    component: TicketHistory,
  },
  USER_PROFILE: {
    name: AppScreens.UserProfile,
    component: UserProfile,
  },
  GAME_SHOW: {
    name: AppScreens.GameShowScreen,
    component: GameShowScreen,
  },
  CHAT: {
    name: AppScreens.Chat,
    component: Chat,
  },
  PAYMENT_SUCCESS: {
    name: AppScreens.PaymentSuccess,
    component: PaymentSuccess,
  },
  PAYMENT_FAILED: {
    name: AppScreens.PaymentFailed,
    component: PaymentFailed,
  },
  PAYMENT_CANCEL: {
    name: AppScreens.PaymentCancel,
    component: PaymentCancel,
  },
  SOLO_STREAMING: {
    name: AppScreens.SoloStreaming,
    component: SoloStreamingPage,
  },
};

export const STACK_SCREENS = {
  HOME: [
    {
      name: "HomeScreen",
      component: HomeWebScreen,
      options: { title: "Home" },
    },
    SHARED_SCREENS.SEARCH_EVENT,
    { name: AppScreens.SearchGameWebScreen, component: SearchGameWebScreen },
    SHARED_SCREENS.PURCHASE,
    SHARED_SCREENS.TICKET_DETAIL,
    {
      name: AppScreens.CreatePublicEventScreen,
      component: CreatePublicEventScreen,
    },
    {
      name: AppScreens.UpdatePublicEventScreen,
      component: UpdatePublicEventScreen,
    },
    {
      name: AppScreens.UpdatePrivateEventScreen,
      component: UpdatePrivateEventScreen,
    },
    {
      name: AppScreens.CreatePrivateEventScreen,
      component: CreatePrivateEventScreen,
    },
    { name: AppScreens.EventSummary, component: EventSummary },
    { name: AppScreens.PrivateEventSummary, component: PrivateEventSummary },
    SHARED_SCREENS.GAME_SHOW,
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    SHARED_SCREENS.USER_PROFILE,
    SHARED_SCREENS.CHAT,
    { name: AppScreens.AddFriends, component: AddFriends },
    { name: AppScreens.SearchMobileScreen, component: SearchMobileScreen },
    SHARED_SCREENS.SETTINGS,
    SHARED_SCREENS.STREAM_SETUP,
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.NOTIFICATIONS,
    { name: AppScreens.MyProfileWebScreen, component: MyProfileWebScreen },
    { name: AppScreens.ChangeAvatar, component: ChangeAvatar },
    { name: AppScreens.OnGoingEvents, component: OnGoingEvents },
    { name: AppScreens.LiveStreaming, component: LiveStreaming },
    { name: AppScreens.PastEvent, component: PastEvent },
    { name: AppScreens.DisputeCenter, component: DisputeCenter },
    SHARED_SCREENS.SOLO_STREAMING,
    SHARED_SCREENS.PAYMENT_SUCCESS,
    SHARED_SCREENS.PAYMENT_FAILED,
    SHARED_SCREENS.PAYMENT_CANCEL,
    { name: AppScreens.StreamerGoLive, component: StreamerGoLive },
  ],

  MY_EVENTS: [
    {
      name: "MyEventsScreen",
      component: MyEventsScreen,
      options: { title: "MyEvents" },
    },
    {
      name: AppScreens.CreatePublicEventScreen,
      component: CreatePublicEventScreen,
    },
    {
      name: AppScreens.UpdatePublicEventScreen,
      component: UpdatePublicEventScreen,
    },
    { name: AppScreens.disputeCenter, component: DisputeCenter },
    {
      name: AppScreens.UpdatePrivateEventScreen,
      component: UpdatePrivateEventScreen,
    },
    {
      name: AppScreens.CreatePrivateEventScreen,
      component: CreatePrivateEventScreen,
    },
    SHARED_SCREENS.PURCHASE,
    { name: AppScreens.EventSummary, component: EventSummary },
    { name: AppScreens.PrivateEventSummary, component: PrivateEventSummary },
    { name: AppScreens.SearchMobileScreen, component: SearchMobileScreen },
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.NOTIFICATIONS,
    SHARED_SCREENS.SETTINGS,
    SHARED_SCREENS.STREAM_SETUP,
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.TICKET_DETAIL,
    SHARED_SCREENS.GAME_SHOW,
    { name: AppScreens.OnGoingEvents, component: OnGoingEvents },
    {
      name: AppScreens.OnGoingEventsStreamingSetup,
      component: OnGoingEventsStreamingSetup,
    },
    { name: AppScreens.GoLive, component: GoLive },
    { name: AppScreens.LiveStreaming, component: LiveStreaming },
    { name: AppScreens.PastEvent, component: PastEvent },
    { name: AppScreens.SearchGameWebScreen, component: SearchGameWebScreen },
    { name: AppScreens.MyProfileWebScreen, component: MyProfileWebScreen },
    { name: AppScreens.ChangeAvatar, component: ChangeAvatar },
    SHARED_SCREENS.USER_PROFILE,
    { name: AppScreens.DisputeCenter, component: DisputeCenter },
    SHARED_SCREENS.CHAT,
  ],

  CHAT: [
    { name: AppScreens.Chat, component: Chat, options: { title: "Chat" } },
    { name: AppScreens.AddFriends, component: AddFriends },
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.NOTIFICATIONS,
    SHARED_SCREENS.SETTINGS,
    { name: AppScreens.Profile, component: MyProfileWebScreen },
    SHARED_SCREENS.STREAM_SETUP,
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.PURCHASE,
  ],

  PROFILE: [
    {
      name: AppScreens.Profile,
      component: MyProfileWebScreen,
      options: { title: "Profile" },
    },
    { name: AppScreens.ChangeAvatar, component: ChangeAvatar },
    SHARED_SCREENS.TICKET_DETAIL,
    SHARED_SCREENS.PURCHASE,
    { name: AppScreens.Redeem, component: RedeemEventScreen },
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    SHARED_SCREENS.USER_PROFILE,
    {
      name: AppScreens.CreatePublicEventScreen,
      component: CreatePublicEventScreen,
    },
    {
      name: AppScreens.UpdatePublicEventScreen,
      component: UpdatePublicEventScreen,
    },
    {
      name: AppScreens.UpdatePrivateEventScreen,
      component: UpdatePrivateEventScreen,
    },
    {
      name: AppScreens.CreatePrivateEventScreen,
      component: CreatePrivateEventScreen,
    },
    { name: AppScreens.RefundRequestScreen, component: RefundRequestScreen },
    { name: AppScreens.EventSummary, component: EventSummary },
    { name: AppScreens.PrivateEventSummary, component: PrivateEventSummary },
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.NOTIFICATIONS,
    SHARED_SCREENS.SETTINGS,
    SHARED_SCREENS.STREAM_SETUP,
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.GAME_SHOW,
    SHARED_SCREENS.CHAT,
  ],

  HELP: [
    {
      name: AppScreens.HelpScreen,
      component: HelpScreen,
      options: { title: "Help" },
    },
    { name: AppScreens.RefundRequestScreen, component: RefundRequestScreen },
    { name: AppScreens.DisputeCenter, component: DisputeCenter },
    { name: AppScreens.ContactUsCenter, component: ContactUsCenter },
    {
      name: AppScreens.CreateTicketEventScreen,
      component: CreateTicketEventScreen,
    },
    SHARED_SCREENS.NOTIFICATIONS,
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.TICKET_DETAIL,
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    SHARED_SCREENS.USER_PROFILE,
    SHARED_SCREENS.GAME_SHOW,
    SHARED_SCREENS.CHAT,
  ],

  NOTIFICATION: [
    {
      name: AppScreens.NotificationScreen,
      component: Notifications,
      options: { title: "Notification" },
    },
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.SETTINGS,
    {
      name: AppScreens.UpdatePublicEventScreen,
      component: UpdatePublicEventScreen,
    },
    SHARED_SCREENS.STREAM_SETUP,
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.TICKET_DETAIL,
    { name: AppScreens.OnGoingEvents, component: OnGoingEvents },
    {
      name: AppScreens.OnGoingEventsStreamingSetup,
      component: OnGoingEventsStreamingSetup,
    },
    { name: AppScreens.GoLive, component: GoLive },
    { name: AppScreens.LiveStreaming, component: LiveStreaming },
    { name: AppScreens.PastEvent, component: PastEvent },
    { name: AppScreens.MyProfileWebScreen, component: MyProfileWebScreen },
    { name: AppScreens.ChangeAvatar, component: ChangeAvatar },
    SHARED_SCREENS.CHAT,
    { name: AppScreens.AddFriends, component: AddFriends },
    SHARED_SCREENS.USER_PROFILE,
    { name: AppScreens.DisputeCenter, component: DisputeCenter },
    SHARED_SCREENS.GAME_SHOW,
    SHARED_SCREENS.PURCHASE,
  ],

  SETTING: [
    {
      name: AppScreens.SettingWebScreen,
      component: SettingWebScreen,
      options: { title: "Setting" },
    },
    { name: AppScreens.ChangeAvatar, component: ChangeAvatar },
    SHARED_SCREENS.STREAM_SETUP,
    SHARED_SCREENS.HELP,
    SHARED_SCREENS.SEARCH_EVENT,
    SHARED_SCREENS.NOTIFICATIONS,
    SHARED_SCREENS.TICKET_DETAIL,
    {
      name: AppScreens.ViewTrasactionHistory,
      component: ViewTrasactionHistory,
    },
    SHARED_SCREENS.TICKET_HISTORY,
    { name: AppScreens.DisputeCenter, component: DisputeCenter },
    SHARED_SCREENS.USER_PROFILE,
    SHARED_SCREENS.GAME_SHOW,
    SHARED_SCREENS.CHAT,
  ],

  PURCHASE: [
    {
      name: AppScreens.PurchaseScreen,
      component: PurchaseScreen,
      options: { title: "Purchase" },
    },
  ],

  DISPUTE: [
    {
      name: AppScreens.DisputeManagementScreen,
      component: DisputeManagementScreen,
    },
    { name: AppScreens.DisputeDetailScreen, component: DisputeDetailScreen },
  ],

  HELP_CHAT: [
    {
      name: AppScreens.CreateTicketEventScreen,
      component: CreateTicketEventScreen,
    },
  ],
};
